import { createFeature, createReducer, on } from '@ngrx/store';
import * as fromArSharesActions from '../actions/annualreport-shares.action';
import { GetShareDto } from '../dtos/getShare.dto';
export interface FeatureState {
    currentActiveUserShares: GetShareDto[] | undefined;
}

export interface AppState {
    aumicoAnnualReportShares: FeatureState;
}

// Selectors Declarations - END

// Reducer Declarations - START

export const initialState: FeatureState = {
    currentActiveUserShares: undefined,
};

const annualReportSharesReducer = createReducer(
    initialState,
    on(fromArSharesActions.getNewAnnualReportsSharedWithMe.do, (state) => ({ ...state, currentActiveUserShares: [] })),
    on(fromArSharesActions.getNewAnnualReportsSharedWithMe.success, (state, action) => ({
        ...state,
        currentActiveUserShares: action.payload,
    })),
    on(fromArSharesActions.getNewAnnualReportsSharedWithMe.failure, (state) => ({
        ...state,
        currentActiveUserShares: [],
    })),
);

export const annualReportSharesFeature = createFeature({
    name: 'aumicoAnnualReportShares',
    reducer: annualReportSharesReducer,
});

export const {
    name,
    reducer, // feature reducer
    selectCurrentActiveUserShares,
} = annualReportSharesFeature;
